import { useCreateEmptyFolder } from '@/hooks/useCreateEmptyFolder';
import { useWorkspaceActions } from '@/hooks/useWorkspace';
import { api } from '@/lib/trpc/react';
import cuid from 'cuid';
import { useEffect, useRef } from 'react';
import { useAuth } from './AuthContext';
import useUpdateUser from './useUpdateUser';
export const useGenerateDefaultChatbot = () => {
  const isGeneratingDefaultBotRef = useRef(false);

  const { user } = useAuth();
  const { updateUser } = useUpdateUser();

  const { createEmptyFolder } = useCreateEmptyFolder();

  const { addChatbot } = useWorkspaceActions();

  const { mutate: generateDefaultChatbot } =
    api.chatbot.createDefaultChatbot.useMutation({
      onMutate: () => {
        if (!user) return;
      },
      onSuccess: (data) => {
        if (!data) return;
        addChatbot({
          ...data,
          parentChatbotId: data.id,
          isIndexed: data.isIndexed,
          ingestionStatus: 'SUCCESS',
          authors: null,
        });
      },
    });
  // NEW USERS ------------------------------------------
  useEffect(() => {
    if (!user || !user.isNewUser || isGeneratingDefaultBotRef.current) return;

    const currentTimeout = setTimeout(() => {
      const groupId = cuid();

      isGeneratingDefaultBotRef.current = true;

      updateUser({
        email: user.email,
        isNewUser: false,
      });

      createEmptyFolder({ id: groupId, name: 'Age reversal research' }, true);
      const publicUrl =
        'https://cdn.infra.unriddle.ai/documents/448c5b58-91f4-4a73-82b9-6bee813ed983';
      const publicUrl2 =
        'https://cdn.infra.unriddle.ai/documents/cf0e5c0f-9ae5-4aab-b1bb-e4bdb00ec6f8';

      generateDefaultChatbot({
        name: 'Chronic inflammation and the hallmarks of aging',
        type: 'DOCUMENT',
        documentUrl: publicUrl,
        groupId,
        oldChatbotId: '448c5b58-91f4-4a73-82b9-6bee813ed983',
      });
      generateDefaultChatbot({
        name: 'Loss of epigenetic information as a cause of mammalian aging',
        type: 'DOCUMENT',
        documentUrl: publicUrl2,
        groupId,
        oldChatbotId: 'cf0e5c0f-9ae5-4aab-b1bb-e4bdb00ec6f8',
      });
    }, 500);

    return () => clearTimeout(currentTimeout);
  }, [user]);
};
